import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="338" height="27" viewBox="0 0 338 27" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" {...props}><path d="M336.02 25.57C237.8 10.52 134.44 12.64 3.59 11m333.24 6.16C256-2.24 176.78-6.84 1 18.27" stroke="#000" strokeWidth="2" strokeLinecap="round" /></svg>);